import { deleteUserData } from "_services";
import {
  deleteAddressBook,
  getAddressBookListData,
  updateStatusAddressBookApi,
} from "_services/accountsServices/addressBookService";
import {
  ButtonHeading,
  CommonModal,
  CustomPagination,
  Heading,
  MapInput,
} from "components";
import BootstrapTable from "components/BootstrapTable";
import { AddAddressBook, AddMapLocationModal } from "modals";
import MastersFilterModal from "modals/MastersFilterModal";
import React, { useContext, useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { AiOutlineEye } from "react-icons/ai";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FaRegTrashCan } from "react-icons/fa6";
import { FiEdit } from "react-icons/fi";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import LoadingBar from "react-top-loading-bar";
import StorageService from "utils/StorageServices/StorageServices";
import RupeeIcon from "../Supplier/RupeeIcon";
import { UserContext } from "context";
import { getZoneDropdownListData } from "_services/dropdownServices/dropdownService";
import useDocumentTitle from "hooks/useDocumentTitle";
import CustomTooltip from "components/CustomTooltip/CustomTooltip";
import { constant } from "constants/constant";

const AddressBook = () => {
  useDocumentTitle("Address Book | T360");
  const { masterData, mastersChild, setMasterDetailsList } = useContext(UserContext);
  const masterChildAddressBook = mastersChild?.find(
    (i) => i?.label === "Address Book"
  );
  const navigate = useNavigate();
  const prevFilterRef = useRef();
  const loadingBarRef = useRef(null);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [addressBooklist, setAddressBookList] = useState([]);
  const [zoneList, setZoneList] = useState([]);
  const [addressId, setAddressId] = useState({
    id: "",
    title: "address",
    view: false,
  });

  const [filter, setFilter] = useState({
    limit: 25,
    offset: 1,
    search: "",
    status: 1,
  });

  const itemsPerPage = 25;
  const [totalItems, setTotalItems] = useState(0);

  const columns = [
    // { header: "", accessor: "serial" },
    { header: "Name", accessor: "name" },
    { header: "Type", accessor: "category" },
    { header: "Firm", accessor: "firm_id" },
    { header: "Associate Party", accessor: "associate_party" },
    { header: "Location", accessor: "locationPoint" },
    { header: "Code", accessor: "code" },
    { header: "City", accessor: "city" },
    { header: "Zone", accessor: "ZoneValue" },
    { header: "Contact", accessor: "contact_no" },
    { header: "Status", accessor: "status" },
    { header: "Action", accessor: "action" },
  ];

  useEffect(() => {
    const prevFilter = prevFilterRef.current;
    if (
      JSON.stringify(prevFilter) !== JSON.stringify(filter)
    ) {
      getAddressBookList();
      prevFilterRef.current = filter;
    }
  }, [filter]);

  useEffect(() => {
    setMasterDetailsList({})
  }, [])

  const getAssociatedPartyNames = (associatePartyArray) => {
    return associatePartyArray?.map((party) => party.name).join(" | ") || "";
  };

  const getAddressBookList = async () => {
    try {
      if (loadingBarRef.current) {
        loadingBarRef.current.continuousStart(); // Start the loading bar
      }
      let object = {
        ...filter,
        company_id: StorageService.getCompanyId(),
        firm_id: StorageService.getFirmId(),
      };
      const res = await getAddressBookListData(object);
      if (res?.responseCode === 200) {
        setAddressBookList(res.data?.addressbook_list);
        setTotalItems(res?.data?.total_record);
      }
    } catch (error) {
      toast.error(error);
    } finally {
      if (loadingBarRef.current) {
        loadingBarRef.current.complete();
      }
    }
  };

  const editHandler = (data) => { };

  const deleteHandler = (item) => {
    setIsDelete(item);
  };

  const handleStatusEvent = async (id, index) => {
    const newStatus = !id?.active;

    const list = [...addressBooklist];

    list[index].active = newStatus;

    setAddressBookList(list);

    const object = {
      company_id: StorageService.getCompanyId(),
      addressbook_id: id?._id,
      active: Number(newStatus),
    };
    statusChangeofUnit(object);
  };

  const statusChangeofUnit = async (obj) => {
    try {
      if (obj) {
        const res = await updateStatusAddressBookApi(obj);
        if (res?.responseCode == 200) {
          toast.success(`${res?.responseMessage}`);
          await getAddressBookList();
        } else {
          toast.error("Error !!");
          await getAddressBookList();
        }
      }
    } catch (error) {
      toast.error(error.message);
      await getAddressBookList();
    }
  };

  const callBackAddressData = () => {
    setAddressId({ id: "", title: "address" });
    getAddressBookList();
  };

  const rowListData = (data) => {
    return data?.map((item, i) => ({
      ...item,
      serial: (
        <React.Fragment>
          <div className="signDropdown">
            <button className="dropbtn11">
              <BsThreeDotsVertical />
            </button>
            <div className="dropdownContent">
              {masterChildAddressBook?.view === 1 && (
                <Link
                  // to={`/account/supplier/details/${item?._id}`}
                  onClick={() => {
                    setAddressId({
                      ...addressId,
                      id: item?._id,
                      title: "address",
                      view: true,
                      isDetailsOnly: true,
                    });
                    setShowOffcanvas(true);
                  }}
                  className="_avPointer"
                  style={{ textDecoration: "none" }}
                >
                  <span className="_samAnchor">
                    <span className="viewIcon_avt">
                      <AiOutlineEye />
                    </span>
                    &nbsp; View
                  </span>
                </Link>
              )}
              {masterChildAddressBook?.edit === 1 && (
                <Link
                  onClick={() => {
                    setAddressId({
                      ...addressId,
                      id: item?._id,
                      title: "address",
                      view: false,
                    });
                    setShowOffcanvas(true);
                  }}
                  className="_avPointer"
                  style={{ textDecoration: "none" }}
                >
                  <span className="_samAnchor">
                    <span className="viewIcon_avt">
                      <FiEdit />
                    </span>
                    &nbsp; Edit
                  </span>
                </Link>
              )}
              {/* <div
                    
                    className='_avPointer'
                  >
                    <span className='_samAnchor'>
                      <span className='editIcon_avt'>
                        <FiEdit />
                      </span>
                      Edit
                    </span>
                  </div> */}

              {masterChildAddressBook?.delete === 1 && (
                <div
                  onClick={(e) => deleteHandler(item)}
                  className="_avPointer"
                >
                  <span className="_samAnchor">
                    <span className="deleteIcon_avt">
                      <FaRegTrashCan color="red" />
                    </span>
                    Delete
                  </span>
                </div>
              )}
            </div>
          </div>
        </React.Fragment>
      ),

      locationPoint:
        item?.location_point == 1
          ? "Loading point / Unit"
          : item?.location_point == 2
            ? "Drop point / Consignee"
            : "-",
      // zoneName: zoneList?.find((i) => i?._id === item?.zone_id)?.name || "",
      zoneName: item?.zone_id?.name || "",
      supplier_name: (
        <Link style={{ textDecoration: "none" }}>
          {item?.company_user_name ? item?.company_user_name : "-"}
        </Link>
      ),

      firm_id: <React.Fragment>
        {item?.firm_id?.firm ? item?.firm_id?.firm : '-'}
      </React.Fragment>,

      contact_number: (
        <React.Fragment>
          {item?.user_id?.mobile_no ? item?.user_id?.mobile_no : "-"}
        </React.Fragment>
      ),
      category: (
        <React.Fragment>
          {
            masterData?.addressbook_category_list.find(
              (fx) => fx?.id == item?.category
            )?.name
          }
        </React.Fragment>
      ),
      party_group: (
        <React.Fragment>
          {item?.consignor_group_id?.name
            ? item?.consignor_group_id?.name
            : "-"}
        </React.Fragment>
      ),
      city: (
        <React.Fragment>
          {item?.city?.label ? item?.city?.label : "-"}
        </React.Fragment>
      ),
      name: (
        <>
          <CustomTooltip txtClass="__tooltipTxt_bx">
            <Link to={`details/${item?._id}?type=${constant.m_type.address_book}&tab=${1}&search=${filter?.search}&offset=${+filter?.offset}&total_record=${totalItems}&name=${item?.name}`} style={{ textDecoration: 'none' }} onClick={() => setMasterDetailsList((s) => ({ ...s, list: addressBooklist, details: item }))}>
              {item?.name ? item?.name : '-'}
            </Link>
          </CustomTooltip>
        </>
      ),
      ZoneValue: (
        <React.Fragment>
          <CustomTooltip txtClass="__tooltipTxt_bx">
            <p>{item?.zone_id?.name ? item?.zone_id?.name : "-"}</p>
          </CustomTooltip>
        </React.Fragment>
      ),
      status: (
        <div
          className="_anvSwitcherNew form-check form-switch"
          style={{ width: "125px" }}
        >
          <input
            className="form-check-input"
            type="checkbox"
            name="actStatus"
            id={`actStatus-${item._id}`}
            autoComplete="off"
            checked={item?.active}
            onChange={() => handleStatusEvent(item, i)}
          />
          <span
            className={
              item?.active
                ? "active_label_masters_status"
                : "disabled_label_masters_status"
            }
          >
            {item?.active ? "Active" : "Disabled"}
          </span>
        </div>
      ),
      associate_party: (
        <React.Fragment>
          {(() => {
            const value = String(
              getAssociatedPartyNames(item?.associate_party_id) || ""
            );

            return value.length > 20 ? (
              <CustomTooltip
                txtClass="__tooltipTxt_bx"
                cstStyle={{ maxWidth: "138px" }}
              >
                <p style={{ marginBottom: 0 }}>{value}</p>
              </CustomTooltip>
            ) : (
              <div className="__NottooltipTxt">
                <p style={{ marginBottom: 0 }}>{value || "-"}</p>
              </div>
            );
          })()}
        </React.Fragment>
      ),
      balance: item?.balance ? (
        <Link
          to={`/account/supplier/details/${item?._id}?tab=4`}
          style={{ textDecoration: "none" }}
        >
          <div
            style={{
              display: "flex",
              gap: "8px",
              alignItems: "center",
              color:
                item.balance < 0
                  ? "#dc3545"
                  : item.balance > 0
                    ? "#28a745"
                    : "#1450ec",
            }}
          >
            <span>
              <RupeeIcon
                color={
                  item.balance < 0
                    ? "#dc3545"
                    : item.balance > 0
                      ? "#28a745"
                      : "#1450ec"
                }
                size={20}
              />
            </span>
            <span>{item?.balance ? Math?.abs(item?.balance)?.toFixed(2) : 0}</span>
          </div>
        </Link>
      ) : (
        <Link
          to={`/account/supplier/details/${item?._id}?tab=4`}
          style={{ textDecoration: "none" }}
        >
          <div
            style={{
              display: "flex",
              gap: "8px",
              alignItems: "center",
              color: "#1450ec",
            }}
          >
            <span>
              <RupeeIcon color="#1450ec" size={20} />
            </span>
            <span>0</span>
          </div>
        </Link>
      ),
      action: (
        <div
          className="_anvSwitcherNew form-check form-switch"
          style={{ width: "100px" }}
        >
          {masterChildAddressBook?.view === 1 && (
            <Link
              // to={`/account/supplier/details/${item?._id}`}
              onClick={() => {
                setAddressId({
                  ...addressId,
                  id: item?._id,
                  title: "address",
                  view: true,
                  isDetailsOnly: true,
                });
                setShowOffcanvas(true);
              }}
              className="_avPointer"
              style={{ textDecoration: "none" }}
            >
              <span className="_samAnchor">
                <span className="viewIcon_avt">
                  <AiOutlineEye color="green" />
                </span>

              </span>
            </Link>
          )}
          {masterChildAddressBook?.edit === 1 && (
            <Link
              onClick={() => {
                setAddressId({
                  ...addressId,
                  id: item?._id,
                  title: "address",
                  view: false,
                });
                setShowOffcanvas(true);
              }}
              className="_avPointer"
              style={{ textDecoration: "none" }}
            >
              <span className="_samAnchor">
                <span className="viewIcon_avt">
                  <FiEdit color="blue" />
                </span>

              </span>
            </Link>
          )}
          {/* <div
                    
                    className='_avPointer'
                  >
                    <span className='_samAnchor'>
                      <span className='editIcon_avt'>
                        <FiEdit />
                      </span>
                      Edit
                    </span>
                  </div> */}

          {masterChildAddressBook?.delete === 1 && (
            <div
              onClick={(e) => deleteHandler(item)}
              className="_avPointer"
            >
              <span className="_samAnchor">
                <span className="deleteIcon_avt">
                  <FaRegTrashCan color="red" />
                </span>

              </span>
            </div>
          )}
        </div>

      ),

    }));
  };

  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, offset: page }));
  };

  const submitDeleteSupplier = async () => {
    setLoading(true);
    try {
      loadingBarRef.current?.continuousStart();
      let object = {
        company_id: isDelete?.company_id,
        addressbook_id: isDelete?._id,
      };

      const res = await deleteAddressBook(object);
      if (res?.responseCode == 200) {
        toast.success(`${res?.responseMessage}`);
        getAddressBookList();
        setLoading(false);
        setIsDelete(false);
      } else {
        toast.success("Error !! ");
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error);
    }
  };

  let propsObject = {
    isOpen: isDelete,
    closeModal: setIsDelete,
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancleTitle: "Close",
    onSubmit: submitDeleteSupplier,
    isLoadding: loading,
  };

  return (
    <div>
      <LoadingBar
        color="#ffa800"
        ref={loadingBarRef}
        height={4}
        shadow={true}
        loaderSpeed={1000}
      />
      <ButtonHeading
        title={"Address Book"}
        onClick={() => setShowOffcanvas(true)}
        buttonTitle={masterChildAddressBook?.create === 1 && "Add Address Book"}
        showSearchFilter={{
          search: true,
          filterOption: false,
          filterCount: true,
        }}
        onClickFilterModal={(e) => setShowFilterModal(false)}
        filter={filter}
        setFilter={setFilter}
        isDebouncedSearch={true}
      />

      <div className="_tabWith_outTab">
        <BootstrapTable
          columns={columns}
          data={rowListData(addressBooklist?.length ? addressBooklist : [])}
          isLoading={loading}
        />

        {addressBooklist?.length > 0 && (
          <div className="paginationFt_avt ">
            {" "}
            <CustomPagination
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              currentPage={filter.offset}
              onPageChange={handlePageChange}
            />
          </div>
        )}
      </div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvas ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: showOffcanvas ? "visible" : "hidden" }}
      ></div>

      <div className={showOffcanvas ? "offBack_drop" : ""}></div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${showFilterModal ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: showFilterModal ? "visible" : "hidden" }}
      >
        {showFilterModal && (
          <MastersFilterModal
            isOpen={showFilterModal}
            onClose={() => setShowFilterModal(false)}
            filter={filter}
            setFilter={setFilter}
            isShow={{
              dateRange: true,
              allBranch: true,
              consignor: true,
            }}
          />
        )}
      </div>
      <div className={showFilterModal ? "offBack_drop" : ""}></div>

      {isDelete?.company_id && (
        <CommonModal {...propsObject}>
          <p className="p-3">
            {" "}
            Are you sure you want to delete {isDelete?.name} ?{" "}
          </p>
        </CommonModal>
      )}

      <div>
        <div
          className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvas ? "show" : ""
            }`}
          tabIndex={-1}
          style={{ visibility: showOffcanvas ? "visible" : "hidden" }}
        >
          {showOffcanvas && (
            <AddAddressBook
              isOpen={showOffcanvas}
              onClose={(e) => {
                setAddressId({ id: "", title: "address", view: false });
                setShowOffcanvas(false);
                getAddressBookList();
              }}
              id={addressId}
              callBackAddressData={callBackAddressData}
            />
          )}
        </div>
        <div className={showOffcanvas ? "offBack_drop" : ""}></div>
      </div>
    </div>
  );
};

export default AddressBook;
